import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import SuccessIndicators from "../SuccessScoreIndicators/SuccessScoreIndicators";
const ProfilePictureWithIndicators = (props) => (_jsxs("div", { className: "d-flex flex-column mr-3", children: [props.profilePicture, props.showIndicators && (_jsx(SuccessIndicators, { termSuccessScore: props.termSuccessScore, courseSuccessScore: props.courseSuccessScore }))] }));
export default ProfilePictureWithIndicators;
